import { useMutation } from '@tanstack/react-query';
import { postUserSellTractorInquiries } from '../../../../api/inquiry/mutations/postUserSellTractorInquiries';

export const usePostUserSellTractorInquiries = () => {
  return useMutation(postUserSellTractorInquiries);
};
